import { coreApi } from '@cp/shared/api/core';
import { ClientsResponse } from '@common/model/admin/clients/clients.response';
import { ClientListRequest } from '@common/model/admin/clients/clients.request';
import { AdminClientImpersonateResponse } from '@common/model/admin/clients/impersonate.response';
import { AdminClientProfileViewModel } from '@common/model/client/profile/adminClientProfileViewModel';
import { ClientAudioResponse } from '@common/model/client/audio/response';
import { AdminCatalogItemApiTag } from 'src/entities/catalog/item';

export const coreClientApi = coreApi
  .enhanceEndpoints({
    addTagTypes: ['CLIENT'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getClients: builder.query<ClientsResponse, ClientListRequest>({
        query: (params) => ({
          url: 'admin/clients',
          method: 'get',
          params,
        }),
      }),

      getClient: builder.query<AdminClientProfileViewModel, { id: number }>({
        query: ({ id }) => ({
          url: `admin/clients/${id}/profile`,
          method: 'get',
        }),
        providesTags: (result) => [{ type: 'CLIENT', id: result?.id }],
      }),

      deleteClient: builder.mutation<void, { id: number }>({
        query: ({ id }) => ({
          url: `admin/clients/${id}`,
          method: 'delete',
        }),
        invalidatesTags: (_result, _error, { id }) => [{ type: 'CLIENT', id }],
      }),

      ban: builder.mutation<void, { id: number }>({
        query: ({ id }) => ({
          url: `admin/clients/${id}/ban`,
          method: 'post',
        }),
        invalidatesTags: (_result, _error, { id }) => [{ type: 'CLIENT', id }],
      }),
      impersonate: builder.mutation<AdminClientImpersonateResponse, { id: number }>({
        query: ({ id }) => ({
          url: `admin/clients/${id}/impersonate`,
          method: 'post',
        }),
      }),
      unban: builder.mutation<void, { id: number }>({
        query: ({ id }) => ({
          url: `admin/clients/${id}/unban`,
          method: 'post',
        }),
        invalidatesTags: (_result, _error, { id }) => [{ type: 'CLIENT', id }],
      }),

      getClientAudio: builder.query<ClientAudioResponse[], { clientId?: number }>({
        query: ({ clientId }) => ({
          url: `admin/clients/${clientId}/audio`,
          method: 'get',
        }),
      }),

      deleteClientAudio: builder.mutation<void, { clientId: number; audioId: number }>({
        query: ({ clientId, audioId }) => ({
          url: `admin/clients/${clientId}/audio/${audioId}`,
          method: 'delete',
        }),
        invalidatesTags: [AdminCatalogItemApiTag.Item],
      }),
    }),
  });
